export default __webpack_public_path__ + "assets/c0cc1af6f60487c3c172fe205f411f9b.jpg";